const hospitalsList = [
    {
      id : "1",
      name: "Banchico Specialist Hospital",
  
      address: "9 Chief Shedrack Ihunwo Cl, Trans Amadi, Port Harcourt 500102, Rivers",
  
      location: {
        lat: 4.816111,
        lng: 7.058333,
        altitude: 35.1,
        accuracy: 4.7,
      },
  
      email: "cjfrancisf@gmail.com",
  
      phoneNumbers: [
        "08084253885",
        "08143036361",
      ],
  
      whatsappNumber: "08084253885",
    },
  ];
  
  module.exports = hospitalsList;